
import * as SparkMD5 from 'spark-md5';
import store from '../../store';

export function getGitHubToken() {
    const { email } = store.getState().user;
    return localStorage.getItem(`ghToken-${email.trim()}`);
}

export function setGitHubTokenAndScope(email, token, scope) {
    localStorage.setItem(`ghToken-${email.trim()}`, token);
    localStorage.setItem(`ghScope-${email.trim()}`, scope);
}

export function getEncGitHubToken(email?: string) {
    const userEmail = email || store.getState().user.email;
    return localStorage.getItem(`alan_enc_github_token_${SparkMD5.hash(userEmail.trim())}`);
}

export function setEncGitHubToken(email, encGithubToken) {
    const userEmail = email || store.getState().user.email;
    localStorage.setItem(`alan_enc_github_token_${SparkMD5.hash(userEmail.trim())}`, encGithubToken);
}

export function clearEncGitHubToken() {
    const { email } = store.getState().user;
    return localStorage.removeItem(`alan_enc_github_token_${SparkMD5.hash(email.trim())}`);
}

export function clearGitHubTokenAndScope() {
    const { email } = store.getState().user;
    localStorage.removeItem(`ghToken-${email.trim()}`);
    localStorage.removeItem(`ghScope-${email.trim()}`);
}